export enum VisitSource {
  App = 'app',
  Embed = 'embed',
}
